var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"feed-likes",class:{ __liked: _vm.isLiked }},_vm.$listeners),[_c('base-icon',{staticClass:"feed-likes__icon mr-1",class:{ 'story-like': _vm.noCount },attrs:{"font-size":24}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }